define('maps/layers/markerlayer',["require", "exports", "../../util/log"], function (require, exports, log) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MarkerLayer = void 0;
    var MarkerLayer = /** @class */ (function () {
        function MarkerLayer(markers) {
            this.googleMarkers = [];
            this.markers = markers;
        }
        MarkerLayer.prototype.onAddGoogle = function (googleMap) {
            var _this = this;
            var _loop_1 = function (pin) {
                // TODO: Check for existing markers
                var marker = new google.maps.Marker({
                    position: pin,
                    map: googleMap,
                    title: pin.name,
                    icon: pin.icon
                });
                marker.addListener("click", function () {
                    log.info("map marker " + pin.name);
                    // Close other markers
                    _this.closeMarker();
                    // Open info window
                    _this.infoWindow = new google.maps.InfoWindow({
                        content: pin.content || pin.name
                    });
                    _this.infoWindow.open(googleMap, marker);
                });
                this_1.googleMarkers.push(marker);
            };
            var this_1 = this;
            // Render markers
            for (var _i = 0, _a = this.markers; _i < _a.length; _i++) {
                var pin = _a[_i];
                _loop_1(pin);
            }
            // Close on click away
            googleMap.addListener("click", function () { return _this.closeMarker(); });
        };
        MarkerLayer.prototype.onRemove = function () {
            for (var _i = 0, _a = this.googleMarkers; _i < _a.length; _i++) {
                var marker = _a[_i];
                marker.setMap(null);
            }
        };
        MarkerLayer.prototype.closeMarker = function () {
            if (this.infoWindow) {
                this.infoWindow.close();
                this.infoWindow = undefined;
            }
        };
        return MarkerLayer;
    }());
    exports.MarkerLayer = MarkerLayer;
});
//# sourceMappingURL=/assets/javascripts/maps/layers/markerlayer.js.map;
